define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var BulkEditCustomerMemberModel = /** @class */ (function () {
        function BulkEditCustomerMemberModel(data) {
            this.EmployeeId = ko.observable();
            this.EmployeeRoleId = ko.observable();
            this.CommissionRoleId = ko.observable();
            this.DeleteMember = ko.observable();
            this.Customers = ko.observableArray();
            this.CustomersIds = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, BulkEditCustomerMemberModel.Mapping, self);
            }
        }
        BulkEditCustomerMemberModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new BulkEditCustomerMemberModel(options.data);
            }
        };
        return BulkEditCustomerMemberModel;
    }());
    return BulkEditCustomerMemberModel;
});
//# sourceMappingURL=BulkEditCustomerMemberModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/BulkEditCustomerMemberModel.js
// module id = 164
// module chunks = 2